const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/common/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        firstname: 'Vorname',
        lastname: 'Name',
        maidenname: 'Lediger Name',
        zusatz: 'Zusatz',
        streetAndNumber: 'Strasse und Nr',
        email: 'E-Mail',
        adresszusatz: 'Adresszusatz',
        country: 'Land',
        telGeneral: 'Telefon',
        tel: 'Telefon Privat',
        mobile: 'Telefon Mobile ',
        office: 'Tel. Büro',
        plz: 'PLZ',
        city: 'Ort',
    },
    __RELATIVE_SOURCE_FILE__
);
